import { Route, Redirect } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../context/AuthContext";
import {hasPermission} from "./roles";

const PrivateRoute = ({ children, resource,...rest }) => {
    const { authTokens, user } = useContext(AuthContext);
    const hasEveryPermission = hasPermission(authTokens, resource, 'view')
    return <Route {...rest}>{!user ? <Redirect to="/login" /> : (!hasEveryPermission ? <Redirect to="/" /> : children)}</Route>;
};

export default PrivateRoute;